import { render, staticRenderFns } from "./Scene.vue?vue&type=template&id=197e372a"
import script from "./Scene.vue?vue&type=script&lang=ts"
export * from "./Scene.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports